import defaultState, { TracksReducer } from './tracksReducerDefaultState'
import { ReduxAction } from '../reducerType'
import { TrackType } from '../../actions/tracks/trackTypes'
import uniq from 'lodash/uniq'

export default function (state: TracksReducer = defaultState, { type, payload }: ReduxAction): TracksReducer {

  switch (type) {

    case TrackType.CREATE_LOCAL_AUDIO_TRACK:
      return {
        ...state,
        hasAudioError: false,
        hasAudioTrack: false,
        isAudioFetching: true,
        numAudioFetchAttempts: state.numAudioFetchAttempts + 1
      }
    case TrackType.CREATE_LOCAL_AUDIO_TRACK_ERROR:
      return {
        ...state,
        hasAudioError: true,
        isAudioFetching: false
      }
    case TrackType.CREATE_LOCAL_AUDIO_TRACK_SUCCESS:
      return {
        ...state,
        hasAudioTrack: true,
        isAudioFetching: false,
        numAudioFetchAttempts: 0
      }
    case TrackType.CREATE_LOCAL_VIDEO_TRACK:
      return {
        ...state,
        hasVideoError: false,
        hasVideoTrack: false,
        isVideoFetching: true,
        numVideoFetchAttempts: state.numVideoFetchAttempts + 1
      }
    case TrackType.CREATE_LOCAL_VIDEO_TRACK_ERROR:
      return {
        ...state,
        hasVideoError: true,
        isVideoFetching: false
      }
    case TrackType.CREATE_LOCAL_VIDEO_TRACK_SUCCESS:
      return {
        ...state,
        hasVideoTrack: true,
        isVideoFetching: false,
        numVideoFetchAttempts: 0
      }
    case TrackType.SET_SELECTED_AUDIO_DEVICE:
      return { ...state, selectedAudioDeviceID: payload }
    case TrackType.SET_SELECTED_VIDEO_DEVICE:
      return { ...state, selectedVideoDeviceID: payload.selectedDevice }
    case TrackType.SET_ENABLED_AUDIO_TRACKS:
      return {
        ...state,
        enabledAudioTracks: uniq(payload)
      }
    case TrackType.SET_ENABLED_AUDIO_TRACK:
      return {
        ...state,
        enabledAudioTracks: uniq([ ...state.enabledAudioTracks, payload ])
      }
    case TrackType.REMOVE_ENABLED_AUDIO_TRACK:
      return {
        ...state,
        enabledAudioTracks: uniq(state.enabledAudioTracks.filter(_trackId => _trackId !== payload))
      }
    case TrackType.SET_ENABLED_VIDEO_TRACK:
      return {
        ...state,
        enabledVideoTracks: uniq([ ...state.enabledVideoTracks, payload ])
      }
    case TrackType.REMOVE_ENABLED_VIDEO_TRACK:
      return {
        ...state,
        enabledVideoTracks: uniq(state.enabledVideoTracks.filter(_trackId => _trackId !== payload))
      }
    case TrackType.SET_AUDIO_SOURCE:
      return {
        ...state,
        audioSource: payload
      }
    case TrackType.REMOVE_LOCAL_AUDIO_TRACK_FOR_DIAL_IN:
      return {
        ...state,
        audioSource: 'telephone'
      }
    default:
      return state

  }

}
